import { Link } from "react-router-dom";
import FaqAccordion from "@/components/feature/FaqAccordion";
import Reveal from "@/components/feature/Reveal";
import { faqs } from "@/mocks/faqs";

export default function FaqPreviewSection() {
  const preview = faqs.slice(0, 5);

  return (
    <section
      aria-labelledby="faq-preview-heading"
      className="w-full border-b border-background-200 bg-background-100/70"
    >
      <div className="mx-auto grid w-full max-w-[1400px] grid-cols-1 gap-10 px-4 py-14 md:px-8 md:py-16 lg:grid-cols-12">
        <div className="lg:col-span-4">
          <p className="label-caps text-[11px] text-primary-600">FAQ</p>
          <h2
            id="faq-preview-heading"
            className="mt-3 font-heading text-2xl font-black text-foreground-950 md:text-3xl"
          >
            常见问题
          </h2>
          <p className="mt-4 text-sm leading-relaxed text-foreground-600">
            关于内容来源、准确性和更新方式，我们把读者最常问的几个问题集中放在这里。如果还有疑问，欢迎通过邮件或表单联系
            编辑部。
          </p>
          <Link
            to="/faq"
            className="mt-6 inline-flex items-center gap-2 whitespace-nowrap rounded-md border border-background-300 bg-background-50 px-4 py-2.5 text-sm font-medium text-foreground-800 transition-colors hover:border-primary-300 hover:text-primary-700 cursor-pointer"
          >
            查看全部问题
            <i className="ri-arrow-right-line" aria-hidden="true" />
          </Link>
        </div>
        <div className="lg:col-span-8">
          <Reveal>
            <FaqAccordion items={preview} defaultOpen={0} />
          </Reveal>
        </div>
      </div>
    </section>
  );
}